import s from './NavArrow.module.scss';

// ── 캐러셀 좌우 네비 화살표(재사용 원본 1개) ──────────────────────────
//   배경/근거: 목업 실측(2026-07-31) 56×56, border #98A2AE, 투명 배경, 색 #636F7E, hover ink-dark.
//   News·Solutions·Trust 세 곳이 동일 → 추출.
//   ★제외: Products 커버플로우 화살표는 정체성(navy 배경/636F7E)·배치(stage 내부 절대위치)가 달라 별도 유지.
type Props = {
  dir: 'prev' | 'next';
  onClick: () => void;
  className?: string;     // 섹션별 배치/여백 덧입힘용(예: Trust flex 아이템)
};

export default function NavArrow({ dir, onClick, className }: Props) {
  const cls = [s.arrow, className].filter(Boolean).join(' ');
  return (
    <button type="button" className={cls} onClick={onClick} aria-label={dir === 'prev' ? '이전' : '다음'}>
      {dir === 'prev' ? '‹' : '›'}
    </button>
  );
}
